/**
 * Global chart color definitions for consistent styling across all charts.
 * Use these colors for all chart components to maintain visual consistency.
 */
export const CHART_COLORS = {
    /** Asset color - indigo */
    asset: {
        stroke: '#6366f1',
        fill: '#6366f1',
        gradientStart: 'rgba(99, 102, 241, 0.3)',
        gradientEnd: 'rgba(99, 102, 241, 0.05)',
    },
    /** Debt color - gray (neutral, avoids negative red connotation) */
    debt: {
        stroke: '#6b7280',
        fill: '#6b7280',
        gradientStart: 'rgba(107, 114, 128, 0.3)',
        gradientEnd: 'rgba(107, 114, 128, 0.05)',
    },
    /** Net Worth color - teal accent */
    netWorth: {
        stroke: '#87C0CD',
        fill: '#87C0CD',
        gradientStart: 'rgba(135, 192, 205, 0.3)',
        gradientEnd: 'rgba(135, 192, 205, 0.05)',
    },
    /** P&L color - emerald green */
    pnl: {
        stroke: '#10b981',
        fill: '#10b981',
        gradientStart: 'rgba(16, 185, 129, 0.3)',
        gradientEnd: 'rgba(16, 185, 129, 0.05)',
    },
} as const;

/**
 * Get chart colors based on ledger type.
 * @param type - 'asset' or 'debt'
 * @returns Chart color configuration for the specified type
 */
export function getChartColorsByType(type: 'asset' | 'debt') {
    return type === 'debt' ? CHART_COLORS.debt : CHART_COLORS.asset;
}
